import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/de";
import { Modal, Box, Button, Typography } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import { ContainedButton } from "../styled/contained-button";

interface IProps {
  userId: string;
  operationDate: dayjs.Dayjs | null;
  onDateChange: (userId: string, date: dayjs.Dayjs) => void;
  updateSelectedDate: (newDate: dayjs.Dayjs, userId: string) => void;
}

export const DateModal: React.FC<IProps> = ({
  userId,
  operationDate,
  onDateChange,
  updateSelectedDate,
}) => {
  const [open, setOpen] = useState(false);
  const [newDate, setNewDate] = useState<dayjs.Dayjs | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAccept = (newDate: dayjs.Dayjs) => {
    if (newDate) {
      onDateChange(userId, newDate);
      updateSelectedDate(newDate, userId);
      handleClose();
    }
  };

  const parsedDate = operationDate
    ? dayjs(operationDate).format("DD/MM/YYYY")
    : "";

  useEffect(() => {
    if (operationDate) {
      setNewDate(dayjs(operationDate));
    } else {
      setNewDate(dayjs());
    }
  }, [operationDate]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        {!operationDate ? (
          <Typography>OP-Datum eingeben</Typography>
        ) : (
          <Typography>{parsedDate}</Typography>
        )}

        <Button
          variant="contained"
          onClick={handleOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0.5,
            minWidth: "auto",
          }}
        >
          <EditCalendarOutlinedIcon
            fontSize="inherit"
            style={{ fontSize: "20px" }}
          />
        </Button>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,

            borderRadius: 2,
          }}
        >
          <Typography variant="h5" mb={2} fontWeight={600} marginBottom={6}>
            Geben Sie das Datum der Operation ein
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
            <DatePicker
              value={newDate}
              onChange={(newDate) => setNewDate(newDate)}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  onKeyDown: (event) => {
                    if (event.key === "Enter") {
                      if (newDate) {
                        handleAccept(newDate);
                        setTimeout(() => handleClose(), 100);
                      }
                    }
                  },
                },
              }}
            />
          </LocalizationProvider>
          <ContainedButton
            onClick={() => {
              if (newDate) {
                handleAccept(newDate);
                handleClose();
              }
            }}
            sx={{ m: 3 }}
          >
            Bestätigen
          </ContainedButton>
        </Box>
      </Modal>
    </>
  );
};
